module.exports = __webpack_public_path__ + "img/side2.34f817b4.png";